const COOKIE_NAME = "cookies_accepted_ursus" // имя кукки
const COOKIE_EXPIRY_DAYS = 365 // количество дней

// Устанавливаем cookie
function setCookie(name, value, days) {
  const date = new Date()
  date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000)
  const expires = "expires=" + date.toUTCString()
  document.cookie = `${name}=${value}; ${expires}; path=/`
}

// Получаем значение cookie
function getCookie(name) {
  const cookies = document.cookie.split(";")
  for (let cookie of cookies) {
    let [cname, cvalue] = cookie.trim().split("=")
    if (cname === name) {
      return cvalue
    }
  }
  return null
}

document.addEventListener("DOMContentLoaded", function() {
  const cookiesBlock = document.querySelector(".js-coockies")
  const acceptBtn = document.querySelector(".js-coockies-accept")
  const cancelBtn = document.querySelector(".js-coockies-cancel")

  // Проверка наличия cookie
  if (!getCookie(COOKIE_NAME)) {
    cookiesBlock.classList.remove("hidden")
  }

  // Обработка клика на "Соглашаюсь"
  acceptBtn.addEventListener("click", function() {
    setCookie(COOKIE_NAME, "true", COOKIE_EXPIRY_DAYS)
    cookiesBlock.classList.add("hidden")
  })

  // Обработка клика на "Отказаться"
  cancelBtn.addEventListener("click", function() {
    cookiesBlock.classList.add("hidden")
  })
})
